export const breakpoints = {
    values: {
        xs: 0,
        sm: 877,
        md: 1175,
        lg: 1473,
        xl: 1548,
    },
};
